import Vue from 'vue'
import {dd,store,app} from 'systems/imports'

import BaseProcessor from 'processor/BaseProcessor'
import API from 'api/Util'

/**
 */
class Util extends BaseProcessor{
  static getClassName(){ return 'Util' }

  /**
   */
  static userAgent(input){
    return new Promise(function(resolve, reject) {
      API.userAgent(input)
        .then((res)=>{
          return resolve({status:"ok",data:{is_desktop:res.is_desktop} })
        }).catch((e)=>{

      })
    });
  }
}

export default Util



// WEBPACK FOOTER //
// ./src/processor/Util.js